import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs'

document.addEventListener("DOMContentLoaded", (event) => {
  if (!customElements.get('hero-slider')) {
    class HeroBanner extends HTMLElement {
      constructor() {
        super();
        this.initializeOptions();
        this.init();
      }

      initializeOptions() {
        this.options = {
          slidesPerView: 1,
          loop: true,
          speed: 800,
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
        };
      }

      init() {
        this.swiper = new Swiper(this, this.options);
        this.swiper?.update();
        this.swiper.on('transitionStart', () => {
            this.classList.add('transitioning');
        });
        this.swiper.on('transitionEnd', () => {
            this.classList.remove('transitioning');
        });
      }
    }

    customElements.define('hero-slider', HeroBanner);
  }
});
